import { clamp, extend, makeArrayProp, padZero } from '@xzx-design/utils'
import { selectSharedProps } from '../../select'
import type { PropType } from 'vue'
import type { SelectOption } from '../../select'

type Filter = (
  columnType: string,
  options: SelectOption[],
  values: string[]
) => SelectOption[]
type Formatter = (type: string, option: SelectOption) => SelectOption

export const sharedProps = extend({}, selectSharedProps, {
  modelValue: makeArrayProp<string>(),
  filter: Function as PropType<Filter>,
  formatter: {
    type: Function as PropType<Formatter>,
    default: (type: string, option: SelectOption) => option,
  },
})

export const selectInheritKeys = Object.keys(selectSharedProps) as Array<
  keyof typeof selectSharedProps
>

export function times<T>(n: number, iteratee: (index: number) => T) {
  if (n < 0) {
    return []
  }

  const result: T[] = Array.from({ length: n })

  let index = -1
  while (++index < n) {
    result[index] = iteratee(index)
  }

  return result
}

export const getMonthEndDay = (year: number, month: number): number =>
  32 - new Date(year, month - 1, 32).getDate()

export const genOptions = <T extends string>(
  min: number,
  max: number,
  type: T,
  formatter: Formatter,
  filter: Filter | undefined,
  values: string[]
) => {
  const options = times(max - min + 1, (index) => {
    const value = padZero(min + index)
    return formatter(type, {
      text: value,
      value,
    })
  })
  return filter ? filter(type, options, values) : options
}

export const formatValueRange = (values: string[], columns: SelectOption[][]) =>
  values.map((value, index) => {
    const column = columns[index]
    if (column.length) {
      const minValue = +column[0].value!
      const maxValue = +column[column.length - 1].value!
      return padZero(clamp(+value, minValue, maxValue))
    }
    return value
  })
